import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import SANUtility from '@sparta.sales.utilities/secure-apply-now-utility/dist/es6.js';
import { link, layerContent } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"layerContent")||(depth0 && lookupProperty(depth0,"layerContent"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"layerContent") : depth0)) != null ? lookupProperty(stack1,"modalLayerLeavingContent") : stack1),{"name":"layerContent","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":21,"column":17}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <p class=\"ada-hidden\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"ariaDisclosure") || (depth0 != null ? lookupProperty(depth0,"ariaDisclosure") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ariaDisclosure","hash":{},"data":data,"loc":{"start":{"line":3,"column":26},"end":{"line":3,"column":44}}}) : helper)))
    + "</p>\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"buttonLocation") : depth0),"!=","below",{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":20,"column":16}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"spa-btn-group\">\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"shopNowButton") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":6,"column":40}}}))
    + "\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"goBackButton") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":7,"column":12},"end":{"line":7,"column":39}}}))
    + "\r\n        </p>\r\n        <p class=\"leaving-msg\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"leavingMssg") || (depth0 != null ? lookupProperty(depth0,"leavingMssg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"leavingMssg","hash":{},"data":data,"loc":{"start":{"line":9,"column":31},"end":{"line":9,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        <p class=\"site-specific-placeholder-content\"></p>\r\n        <div class=\"spa-content-alpha-layer\"></div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"leaving-msg\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"leavingMssg") || (depth0 != null ? lookupProperty(depth0,"leavingMssg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"leavingMssg","hash":{},"data":data,"loc":{"start":{"line":13,"column":31},"end":{"line":13,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        <p class=\"spa-btn-group\">\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"shopNowButton") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":15,"column":12},"end":{"line":15,"column":40}}}))
    + "\r\n            "
    + container.escapeExpression((lookupProperty(helpers,"link")||(depth0 && lookupProperty(depth0,"link"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"goBackButton") : stack1),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":16,"column":39}}}))
    + "\r\n        </p>\r\n        <p class=\"site-specific-placeholder-content\"></p>\r\n        <div class=\"spa-content-alpha-layer\"></div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":22,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/leaving-modal-module",
  "version": "2.0.0",
  "id": "leaving-modal-module",
  "containerID": "autoLoansLeavingModalModule",
  "moduleName": "auto-loans-leaving-modal-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "leaving-modal-module",
  "data": {
    "init": "leavingModalModuleJS"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        link,
        layerContent,
        compare
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    link,
    layerContent,
    compare
  },
  "dependencies": {
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.5",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.sales.utilities/secure-apply-now-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @class leavingModalModuleJS
 * @extends {Module}
 */
class leavingModalModuleJS extends Module {
  /**
   * Creates an instance of leavingModalModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof leavingModalModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.id = options.target.id;
    this.$module = this.settings.$target;
    this.container = document.getElementById('modalLayerLeavingContentSpartaUILayer');
    this.SanUtility = SANUtility.GeneralUtility;
    this.initializedModal = false;
  }

  /**
   * Runs on module init
   * @returns {void}
   */
  init() {
    document.querySelector('#goBackToBACButton_shopNow').addEventListener('click', () => {
      document.querySelector('.spa-ui-layer-close').click();
    });
    this.observeClassesOfBody(this.handleDeviceOrientation.bind(this));
    this.Events.sub('MODAL_OPENED.spartaUILayersUtility', () => {
      if (!this.initializedModal) {
        const headerClasses = 'leaving-modal-header';
        this.modal = document.getElementById('modalLayerLeavingContentSpartaUILayer') || document.getElementById('language-change-defaultSpartaUILayer');
        this.spa_body = this.modal.querySelectorAll('.spa-card__body');
        this.spa_content = this.modal.querySelector('.spa-layer-content');
        this.spa_dialog = this.modal.querySelectorAll('.spa-dialog');
        this.spa_header = this.modal.querySelector('.spa-card__head');
        this.spa_cardHeader = this.modal.querySelector('.spa-card__head-wrapper');
        this.spa_cardHeader.classList.remove('spa-card__head-wrapper-white');
        this.spa_cardHeader.classList.add('spa-card__head-wrapper-red');
        this.spa_header.classList.add(headerClasses);
        [...this.modal.querySelectorAll('.spa-close-x')].forEach(el => {
          el.classList.add('white-text');
        });
        [...this.modal.querySelectorAll('.spa-content-alpha-layer')].forEach(el => {
          el.classList.remove('spa-content-alpha-layer');
        });
        this.spa_content.classList.add('leaving-modal-bkg');
        [...this.spa_dialog].forEach(el => el.classList.add('spa-dialog-width'));
        this.initializedModal = true;
      }
    });
  }

  /**
   * @name applyLandscapeMode
   * @returns {undefined}
   */
  applyLandscapeMode() {
    this.spa_dialog.forEach(el => {
      el.classList.add('dialog-style-landscape');
    });
    this.spa_body.forEach(el => {
      el.classList.add('body-style');
    });
  }

  /**
   * @name applyPortraitMode
   * @returns {undefined}
   */
  applyPortraitMode() {
    if (this.modal) {
      this.spa_dialog.forEach(el => {
        el.classList.add('dialog-style-standard');
      });
    }
  }

  /**
   * @param {Array} arr array
   * @returns {Boolean} is in small landscape mode
   */
  isInSmallLandscapeMode(arr) {
    const smallLandscapeClasses = ['small-only', 'landscape'];
    return this.SanUtility.areAllValuesInAnotherArray(smallLandscapeClasses, arr);
  }

  /**
   * @param {Array} arr array
   * @returns {Boolean} is in small landscape mode
   */
  isInSmallPortraitMode(arr) {
    const smallPortraitClasses = ['small-only', 'portrait'];
    return this.SanUtility.areAllValuesInAnotherArray(smallPortraitClasses, arr);
  }

  /**
   * @param {HTMLElement} mutationRecord mutation record
   * @description this is the callback for when the body changes class and we want to respond
   * with the device orientation
   * @returns {undefined}
   */
  handleDeviceOrientation(mutationRecord) {
    const objClasses = mutationRecord.target.classList;
    const bodyClasses = this.SanUtility.convertObjectToArray(objClasses);
    if (this.isInSmallLandscapeMode(bodyClasses) && this.modal) {
      this.applyLandscapeMode();
    } else if (this.isInSmallPortraitMode(bodyClasses) && this.modal) {
      this.applyPortraitMode();
    }
  }

  /**
   *
   * @description when Sparta determines device orientation change,
   * we do our stuff using that knowledge (small-only, xlarge-only etc)
   * @param {Function} callback
   * @returns {undefined}
   */
  observeClassesOfBody(callback) {
    const options = {
      attributes: true,
      attributeOldValue: true,
      // Only captures changes to the class attribute
      attributeFilter: ['class']
    };
    this.SanUtility.createElementObserver(document.body, options, callback);
  }
}
registerModuleClass({
  moduleClass: leavingModalModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { leavingModalModuleJS as default, moduleConfig };
